import type { StaticLayerPayload } from "@config";
import { GroupLibrary } from "@library-layers/group";
import { Container } from "../Container";

export const Group = ({ entity }: StaticLayerPayload) => (
  <Container entity={entity} views={{ default: GroupLibrary }} />
);
